import RequestDemo from "./RequestDemo";
import { Link } from "react-router-dom";
import Logo from "/images/drone-stream-svg-logo.svg";
export default function Header() {
    const baseUrl = import.meta.env.VITE_PRODUCT_FRONTEND_URL || "/";
    return(
        <>
        <header className="tf-header-landing">
            <div className="container-6">
                <div className="row align-items-center">
                    <div className="col-8 col-lg-3 col-md-5 m-auto">
                        <div className="logo-site">
                            <Link to={baseUrl}>
                                <img loading="lazy" src={Logo} alt="InfinitiveHost Logo" className="w-100" />
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-3 d-none d-md-block">
                    </div>
                    <div className="col-4 col-lg-3 col-md-4 d-none d-md-block">
                        <div className="header-right">
                            <button className="tf-btn-2 has-icon d-none d-ssm-inline-flex">
                                <div className="wrap-text text-body-2 fw-medium text-white">
                                    <div className="ic-wrap">
                                        <i className="fa-solid fa-arrow-right arrow-right"></i>
                                    </div>
                                    <span className="text text-linear" data-bs-toggle="modal" data-bs-target="#reqDemo">
                                        Request Demo
                                    </span>
                                </div>
                            </button>
                            <a href="#mobileMenu" data-bs-toggle="offcanvas"
                                className="btn-mobile-menu-2 style-primary d-md-none">
                                <span></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        
        <RequestDemo/>
        </>
    )
}